import difference from 'lodash/difference';

import plaidActions from 'core/plaid/actions';
import pageActions from '../page/actions';
import fieldActions from '../fields/actions';
import groupActions from './actions';

const getGroupsWithCleanFields = (fields, groups) => {
  if (!fields || !groups) {
    return groups;
  }
  const lookupCompositeFields = Object.keys(fields).reduce((lFArr, key) => {
    if (fields[key].fieldType === 'LOOKUP_COMPOSITE') {
      const { lookupFieldMap } = fields[key];
      return [
        ...lFArr,
        ...Object.keys(lookupFieldMap).reduce(
          (arr, mapKey) => [...arr, ...lookupFieldMap[mapKey]],
          [],
        ),
      ];
    }
    return lFArr;
  }, []);
  return Object.keys(groups).reduce((newGroups, groupKey) => {
    const group = groups[groupKey];
    return {
      ...newGroups,
      [groupKey]: {
        ...group,
        fields: difference(group.fields, lookupCompositeFields),
      },
    };
  }, {});
};

export default (state = {}, action) => {
  switch (action.type) {
    case groupActions.UPDATE_SUCCESS:
    case pageActions.GO_SUCCESS:
    case groupActions.NEXT_SUCCESS: {
      /** HACK: This should be removed when the prod start page
       * is replaced with the product showcase
       */
      if (action.payload.data.meta?.page?.name === 'prodstart') {
        return {
          ...action.payload.data.meta.groups,
          PROD_START: {
            ...action.payload.data.meta.groups.PROD_START,
            fields: ['productLookup'],
          },
        };
      }
      if (action.payload.data.data?.questions?.length > 0) {
        const groupState = action.payload.data.meta.groups || state;
        const fields = action.payload.data.data.questions.map(
          (question) => `KBA_questions${question.id}`,
        );
        return Object.keys(groupState).reduce((newState, key) => {
          if (groupState[key].name === 'KBA') {
            return {
              ...newState,
              [key]: {
                ...groupState[key],
                fields,
              },
            };
          }
          return {
            ...newState,
            ...groupState[key],
          };
        }, {});
      }
      return getGroupsWithCleanFields(
        action.payload.data.meta.fields,
        action.payload.data.meta.groups || state,
      );
    }
    case fieldActions.RERENDER_SUCCESS:
    case groupActions.UPLOAD_SUCCESS:
      return getGroupsWithCleanFields(
        action.payload.data.meta.fields,
        action.payload.data.meta.groups || state,
      );
    case groupActions.NEXT_FAILED:
    case groupActions.UPLOAD_FAILED:
    case pageActions.NEXT_FAILED: {
      const getGroupError = (key) => (key.startsWith('*_') ? key.substring(2) : null);
      const UPLOAD_ERROR = '*_PRIMARY_DL';
      const UPLOAD_ERROR_SECONDARY = '*_SECONDARY_DL';
      const UPLOAD_ERROR_SIGNER = '*_SIGNER_DL';
      const { data } = action.payload;
      const response = data.result || data.meta;
      /* Object.assign() is used here instead of spread due to a cross browser issue on Safari.
       * Safari was reordering the groups.
       */
      return {
        ...state,
        ...(data.meta && data.meta.groups),
        ...Object.keys(response.msgs).reduce((newGroups, key) => {
          if (state[key]) {
            return {
              ...newGroups,
              [key]: {
                ...state[key],
                error: true,
                errorMsg: response.msgs[key],
              },
            };
          }
          if (key === UPLOAD_ERROR) {
            return {
              ...newGroups,
              PRIMARY_DL: {
                ...state.PRIMARY_DL,
                error: true,
                errorMsg: response.msgs[key],
              },
            };
          }
          if (key === UPLOAD_ERROR_SECONDARY) {
            return {
              ...newGroups,
              SECONDARY_DL: {
                ...state.SECONDARY_DL,
                error: true,
                errorMsg: response.msgs[key],
              },
            };
          }
          if (key === UPLOAD_ERROR_SIGNER) {
            return {
              ...newGroups,
              SIGNER_DL: {
                ...state.SIGNER_DL,
                error: true,
                errorMsg: response.msgs[key],
              },
            };
          }
          const groupKey = getGroupError(key);
          if (groupKey && state[groupKey]) {
            return {
              ...newGroups,
              [groupKey]: {
                ...state[groupKey],
                error: true,
                errorMsg: response.msgs[key],
              },
            };
          }
          return newGroups;
        }, {}),
      };
    }
    case plaidActions.FETCH_ACCOUNTS_SUCCESS:
      if (action.payload.data.meta.groups.FUNDING_TRANSFER_EXT) {
        return {
          ...state,
          FUNDING_TRANSFER_EXT: action.payload.data.meta.groups.FUNDING_TRANSFER_EXT,
        };
      }
      return {
        ...state,
        ...action.payload.data.meta.groups,
      };
    case plaidActions.HANDLE_VERIFICATION_QUESTIONS:
      return {
        ...state,
        FUNDING_EXT_VERIFICATION: action.payload.data.meta.groups.FUNDING_EXT_VERIFICATION,
      };
    case groupActions.HANDLE_VERIFICATION_OPTIONS:
      return {
        ...state,
        [action.payload.groupName]: {
          ...state[action.payload.groupName],
          fields: state[action.payload.groupName].fields.filter(
            (itm) => itm !== action.payload.mobileField,
          ),
        },
      };
    case groupActions.NEXT: {
      const { group } = action.payload;
      if (state[group] && state[group].error) {
        return {
          ...state,
          [group]: {
            ...state[group],
            error: false,
            errorMsg: '',
          },
        };
      }
      return state;
    }
    case pageActions.SAVE_BENEFICIARY: {
      if (state.BENEFICIARIES && state.BENEFICIARIES.error) {
        return {
          ...state,
          BENEFICIARIES: {
            ...state.BENEFICIARIES,
            error: false,
            errorMsg: '',
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
};
